import { render, staticRenderFns } from "./order_management.vue?vue&type=template&id=78595417&"
import script from "./order_management.vue?vue&type=script&lang=js&"
export * from "./order_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports